import * as React from 'react'
import { type Fragment } from 'react'
import { type TabValue, useTabContext } from '../TabContext/TabContext'

export interface TabPanelProps extends React.ComponentPropsWithoutRef<typeof Fragment> {
  /** 對應的標籤值，與 TabContext 的 value 比對以決定是否顯示 */
  value: TabValue
}

/**
 * TabPanel 標籤面板，僅在其 value 與 TabContext 當前值相符時渲染子內容。
 */
export const TabPanel = (props: TabPanelProps) => {
  const { value, children } = props
  const { value: selectedValue } = useTabContext()

  if (selectedValue !== value) return null

  return <>{children}</>
}
